import React, { Component } from 'react';
import { FormModalContainer, FormModalContent } from '../style';
import { BackIconContainer } from '../../style';
import { Text } from '../../../../UI/Text';
import { YoutubeVideoModalContent, Input, SaveButton } from './style';
import { colorNames } from '../../../../../Constants/colors';

export class ChooseYoutubeVideoModal extends Component {
    state = {
        videoLink: '',
    };

    handleChange = ({ target }) => this.setState({ videoLink: target.value });

    onSelect = () => {
        const { onSelect, initialModalType } = this.props;
        onSelect(initialModalType, {
            type: initialModalType,
            content_type: 5,
            youtube_link: this.state.videoLink,
        });
    };

    render() {
        const {
            props: { onClose, title },
            state: { videoLink },
            handleChange,
            onSelect,
        } = this;
        const isButtonDisabled = videoLink.length === 0;

        return (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        {title}
                    </Text>

                    <BackIconContainer onClick={onClose}>
                        <i className="fas fa-chevron-left" />
                    </BackIconContainer>

                    <YoutubeVideoModalContent>
                        <Text color={colorNames.GREY} marginBottom={'10px'} weight={'bold'}>
                            Add YouTube link
                        </Text>

                        <Input value={videoLink} onChange={handleChange} />

                        <Text
                            color={colorNames.GREY}
                            fontSize={10}
                            marginTop={'10px'}
                            marginBottom={'10px'}
                            weight={'100'}
                            opacity={0.5}
                        >
                            Paste URL of YouTube video above.
                        </Text>

                        <SaveButton onClick={onSelect} disabled={isButtonDisabled}>
                            Save
                        </SaveButton>
                    </YoutubeVideoModalContent>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

ChooseYoutubeVideoModal.defaultProps = {
    type: 0,
    title: 'Add video',
    onClose: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/Modals/ChooseYoutubeVideoModal.js